<template>
  <div class="panel-in-tab">
    <!-- 搜索 -->
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="品类细分" prop="category">
          <el-select v-model="searchForm.categoryName" filterable multiple collapse-tags reserve-keyword>
            <el-option v-show="!all" label="全部" value=""></el-option>
            <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in varietyList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上市时间">
          <form-date-range :form="searchForm" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
        </el-form-item>
        <el-form-item label="付款时间">
          <el-date-picker v-model="searchForm.payStartTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" :clearable="false" :editable="false"></el-date-picker>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>
    <!-- 列表 -->
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="onExport">导出</el-button>
        <el-button type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
      </template>
      <el-table
        stripe
        border
        ref="table"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData"
        :height="maxTableHeight + 42"
        @sort-change="handleSortChange"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          :sortable="item.sortable ? 'custom' : false"
          show-overflow-tooltip
          v-for="item in columnData"
          :key="item.prop"
          :align="item.align"
        >
          <template slot="header">
            <template v-if="item.label.includes('销量')">
              <span>{{ item.label }}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <span class="el-icon-question"></span>
                <div slot="content">包含京东入仓销量</div>
              </el-tooltip>
            </template>
          </template>
          <template slot-scope="scope">
            <template v-if="item.label === '图片'">
              <template v-if="showDetailBtn(scope.row)">
                <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
              </template>
            </template>
            <template v-else>
              {{ scope.row[item.prop] | cellValFormat }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>
    <!-- 自定义列 -->
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="customForm" @confirm="confirm"></custom-table>
  </div>
</template>

<script>
import moment from 'moment';
import picVideoMxin from '../pic&video.mixin';
import importExportMxin from '../import&export.mixin';
import customProps from '../customProps.mixin';
import tableMixin from '@/utils/tableMixin';
export default {
  name: 'PoorStores',
  mixins: [picVideoMxin, importExportMxin, customProps, tableMixin],
  data() {
    return {
      header_H: '38px',
      searchCollapse: false,
      loading: false,
      exportLoading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      all: false,
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      varietyList: [],
      loading: false,
      searchForm: {
        categoryName: [],
        hundredSaleNumFlag: '',
        type: 1,
        startTime: '',
        endTime: '',
        payStartTime: '',
      },
      exportData: {},
      tableData: [],
      year: '',
      orderDto: {},
      yearNum: 0,
      monthNum: 0,
      Time: '',
      activeTable: 0,
      filterPropertyName: [],
      changeTime: false,
      changeType: false,
      tableReload: true,
      cloumnVal: '',
    };
  },
  computed: {
    tableHeight() {
      if (!this.searchCollapse) {
        return window.innerHeight - 233;
      } else {
        let formHeight = (this.$refs['searchWrapper'] && this.$refs['searchWrapper'].offsetHeight) || 0;
        return window.innerHeight - formHeight - 233 + 49;
      }
    },
    windowWidth() {
      return document.body.clientWidth;
    },
    categoryName() {
      return JSON.parse(JSON.stringify(this.searchForm.categoryName));
    },
  },
  watch: {
    categoryName: {
      handler(val, oldval) {
        if (val.includes('') && val.length && this.varietyList.length) {
          this.searchForm.categoryName = [].concat(this.varietyList);
          this.all = true;
        } else if (val.indexOf('cancleAll') != -1 && oldval.indexOf('cancleAll') == -1 && oldval.length >= 1) {
          this.all = false;
          this.searchForm.categoryName = [];
        }
      },
    },
  },
  methods: {
    format(input) {
      //千分位转换
      var n = parseFloat(input).toFixed(2);
      var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
      return n.replace(re, '$1,');
    },

    onSearch(data) {
      this.tableData.pageNum = 1;
      this.getOptionTypes();
      this.init();
    },

    init(type) {
      this.loading = true;
      this.tableData = [];
      // if (this.searchForm.startTime) {
      //   this.year = "";
      // }
      let searchForm = {
        ...this.searchForm,
        // filterPropertyName: this.checkAll ? [] : this.filterPropertyName,
        // year: this.year,
        ...this.orderDto,
      };
      console.log(this.activeTable);
      // if (this.orderDto.propertyName && this.filterPropertyName.length) {
      //   if (
      //     !this.filterPropertyName
      //       .map((v) => v.fieldName)
      //       .includes(this.orderDto.propertyName)
      //   ) {
      //     //当前排序了的列筛选删除对应参数清除
      //     searchForm.propertyName = "";
      //     searchForm.order = "";
      //   }
      // }
      this.exportData = searchForm;
      this.$q.goodsAnalysis
        .saleProductList({ data: searchForm })
        .then((res) => {
          this.tableData = res.data.dataList;
          if (!type) {
            this.pagingColumnData = res.data.keyAndVal;
            this.dynamicCustomColumn();
          }
        })
        .finally((_) => {
          this.loading = false;
        });

      // console.log(searchForm);
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(true);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(true);
    },
    reset() {
      if (this.$refs['table']) {
        this.$refs['table'].clearSort(); //切换清除排序
      }
      // this.filterPropertyName = [];
      let query = this.$route.query;
      this.searchForm = {
        categoryName: [],
        hundredSaleNumFlag: '',
        endTime: query.endTime,
        startTime: query.startTime,
        payStartTime: query.startTime ? moment(query.startTime).subtract(2, 'months').format('YYYY-MM-DD') : '',
        type: 1,
      };
      this.orderDto = {};
      this.init();
    },
    onCollapse(val) {},
    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.orderDto = {
        propertyName: prop,
        order: order === 'ascending' ? 'ASC' : order === 'descending' ? 'DESC' : '',
      };

      this.init(true);
    },
    getOptionTypes() {
      this.$q.goodsAnalysis
        .interface({
          data: {
            startTime: this.searchForm.startTime,
            endTime: this.searchForm.endTime,
            reportType: this.activeTable,
            type: 1,
          },
        })
        .then((res) => {
          this.varietyList = res.data;
          console.log(res);
        });
    },
    strartTimeChange() {
      this.$set(this.searchForm, 'payStartTime', moment(this.searchForm.startTime).subtract(2, 'months').format('YYYY-MM-DD'));
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    let buttonJurisdiction = JSON.parse(localStorage.getItem('permitList')); //列展示权限获取
    let Jurisdiction = 'ec-pc-new$analysisDashboard$productAnalysis$yearBehavior$prices';
    this.columnJurisdiction = buttonJurisdiction.includes(Jurisdiction);
    let query = this.$route.query;
    this.searchForm.startTime = query.startTime || '';
    this.searchForm.payStartTime = query.payStartTime || '';
    this.searchForm.endTime = query.endTime || '';
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important
>>> .el-link.el-link--primary
  margin-right 5px
</style>
